import { NotificationType } from '@dynamik/common/clients/notification-clients';

export class NotificationTypeValueConverter {
  toView(nt: NotificationType): string {
    return NotificationType[nt];
  }
}
